<form [formGroup]="form">
  <mat-accordion>
    <mat-expansion-panel [expanded]="expandedFilter" (opened)="expandedFilter = true"
      (closed)="expandedFilter = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'executionList.filter.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.documentCode.label' | translate }}</mat-label>
            <input matInput
              formControlName="documentCode" [(ngModel)]="filter.documentCode">
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.protocol.label' | translate }}</mat-label>
            <input matInput
              formControlName="documentCodeProtocol" [(ngModel)]="filter.documentCodeProtocol">
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{'protocolEdit.general.client.label' | translate}}</mat-label>
            <mat-select #clientSelect formControlName="idClient" [(ngModel)]="filter.idClient">
              @if (clientSelect.focused) {
                <mat-select-filter [displayMember]="'name'" [array]="clients"
                  (filteredReturn)="clientsFiltered =$event"
                  [noResultsMessage]="'common.noResults' | translate"></mat-select-filter>
              }
              @for (client of clientsFiltered; track client) {
                <mat-option [value]="client.id">
                  {{ client.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.projectNo.label' | translate }}</mat-label>
            <input matInput
              formControlName="projectNo" [(ngModel)]="filter.projectNo">
          </mat-form-field>
        </div>

      </div>

      <mat-accordion>
        <mat-expansion-panel expanded="false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'executionList.filter.advanced.title' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.equipment.label' | translate }}</mat-label>
                <input matInput
                  formControlName="equipment" [(ngModel)]="filter.equipment">
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.equipmentSerialNum.label' | translate }}</mat-label>
                <input matInput
                  formControlName="equipmentSerialNum" [(ngModel)]="filter.equipmentSerialNum">
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.equipmentInternalId.label' | translate }}</mat-label>
                <input matInput
                  formControlName="equipmentInternalId" [(ngModel)]="filter.equipmentInternalId">
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.projectManager.label' | translate }}</mat-label>
                <mat-select formControlName="projectManager" [(ngModel)]="filter.projectManager">
                  <mat-option [value]="null"> --- </mat-option>
                  @for (item of projectManagers; track item) {
                    <mat-option [value]="item.username">
                      {{ item.fullName }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.clientDocumentCode.label' | translate }}</mat-label>
                <input matInput
                  formControlName="clientDocumentCode" [(ngModel)]="filter.clientDocumentCode">
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.status.label' | translate }}</mat-label>
                <mat-select formControlName="idStatus" [(ngModel)]="filter.idStatus">
                  <mat-option [value]="null"> --- </mat-option>
                  @for (item of statuses; track item) {
                    <mat-option [value]="item.id">
                      {{ 'executionStatus.' + item.translation | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>


            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.process.label' | translate }}</mat-label>
                <mat-select formControlName="idProcess" [(ngModel)]="filter.idProcess">
                  <mat-option [value]="null"> --- </mat-option>
                  @for (item of processes; track item) {
                    <mat-option [value]="item.id">
                      {{ 'processType.' + item.translation | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.phase.label' | translate }}</mat-label>
                <mat-select formControlName="phase" [(ngModel)]="filter.idPhase">
                  <mat-option [value]="null"> --- </mat-option>
                  @for (item of phases; track item) {
                    <mat-option [value]="item.id">
                      {{ 'phase.' + item.translation | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.regUser.label' | translate }}</mat-label>
                <mat-select formControlName="regUser" [(ngModel)]="filter.regUser">
                  <mat-option [value]="null"> --- </mat-option>
                  @for (item of users; track item) {
                    <mat-option [value]="item.username">
                      {{ item.fullName }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.equipmentMaker.label' | translate }}</mat-label>
                <input matInput
                  formControlName="equipmentMaker" [(ngModel)]="filter.equipmentMaker">
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.equipmentModel.label' | translate }}</mat-label>
                <input matInput
                  formControlName="equipmentModel" [(ngModel)]="filter.equipmentModel">
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.equipmentLocation.label' | translate }}</mat-label>
                <input matInput
                  formControlName="equipmentLocation" [(ngModel)]="filter.equipmentLocation">
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="datepicker">
                <mat-label>{{ 'executionList.filter.regFcStart.label' | translate }}</mat-label>
                <input matInput [matDatepicker]="regFcStartPicker" formControlName="regFcStart"
                  [ngModel]="filter.regFcStart" (blur)="saveDate('regFcStart', $event)"
                  (dateChange)="saveDate('regFcStart', $event)">
                <mat-datepicker-toggle matSuffix [for]="regFcStartPicker"></mat-datepicker-toggle>
                <mat-datepicker #regFcStartPicker >
                </mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="datepicker">
                <mat-label>{{ 'executionList.filter.regFcEnd.label' | translate }}</mat-label>
                <input matInput [matDatepicker]="regFcEndPicker" formControlName="regFcEnd"
                  [ngModel]="filter.regFcEnd" (blur)="saveDate('regFcEnd', $event)"
                  (dateChange)="saveDate('regFcEnd', $event)">
                <mat-datepicker-toggle matSuffix [for]="regFcEndPicker"></mat-datepicker-toggle>
                <mat-datepicker #regFcEndPicker >
                </mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="datepicker">
                <mat-label>{{ 'executionList.filter.modFcStart.label' | translate }}</mat-label>
                <input matInput [matDatepicker]="modFcStartPicker" formControlName="modFcStart"
                  [ngModel]="filter.modFcStart" (blur)="saveDate('modFcStart', $event)"
                  (dateChange)="saveDate('modFcStart', $event)">
                <mat-datepicker-toggle matSuffix [for]="modFcStartPicker"></mat-datepicker-toggle>
                <mat-datepicker #modFcStartPicker >
                </mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="datepicker">
                <mat-label>{{ 'executionList.filter.modFcEnd.label' | translate }}</mat-label>
                <input matInput [matDatepicker]="modFcEndPicker" formControlName="modFcEnd"
                  [ngModel]="filter.modFcEnd" (blur)="saveDate('modFcEnd', $event)"
                  (dateChange)="saveDate('modFcEnd', $event)">
                <mat-datepicker-toggle matSuffix [for]="modFcEndPicker"></mat-datepicker-toggle>
                <mat-datepicker #modFcEndPicker >
                </mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="datepicker">
                <mat-label>{{ 'executionList.filter.workEndFcStart.label' | translate }}</mat-label>
                <input matInput [matDatepicker]="workEndFcStartPicker" formControlName="workEndFcStart"
                  [ngModel]="filter.workEndFcStart" (blur)="saveDate('workEndFcStart', $event)"
                  (dateChange)="saveDate('workEndFcStart', $event)">
                <mat-datepicker-toggle matSuffix [for]="workEndFcStartPicker"></mat-datepicker-toggle>
                <mat-datepicker #workEndFcStartPicker >
                </mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="datepicker">
                <mat-label>{{ 'executionList.filter.workEndFcEnd.label' | translate }}</mat-label>
                <input matInput [matDatepicker]="workEndFcEndPicker" formControlName="workEndFcEnd"
                  [ngModel]="filter.workEndFcEnd" (blur)="saveDate('workEndFcEnd', $event)"
                  (dateChange)="saveDate('workEndFcEnd', $event)">
                <mat-datepicker-toggle matSuffix [for]="workEndFcEndPicker"></mat-datepicker-toggle>
                <mat-datepicker #workEndFcEndPicker >
                </mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="datepicker">
                <mat-label>{{ 'executionList.filter.realizationFcStart.label' | translate }}</mat-label>
                <input matInput [matDatepicker]="realizationFcStartPicker" formControlName="realizationFcStart"
                  [ngModel]="filter.realizationFcStart" (blur)="saveDate('realizationFcStart', $event)"
                  (dateChange)="saveDate('realizationFcStart', $event)">
                <mat-datepicker-toggle matSuffix [for]="realizationFcStartPicker"></mat-datepicker-toggle>
                <mat-datepicker #realizationFcStartPicker >
                </mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="datepicker">
                <mat-label>{{ 'executionList.filter.realizationFcEnd.label' | translate }}</mat-label>
                <input matInput [matDatepicker]="realizationFcEndPicker" formControlName="realizationFcEnd"
                  [ngModel]="filter.realizationFcEnd" (blur)="saveDate('realizationFcEnd', $event)"
                  (dateChange)="saveDate('realizationFcEnd', $event)">
                <mat-datepicker-toggle matSuffix [for]="realizationFcEndPicker"></mat-datepicker-toggle>
                <mat-datepicker #realizationFcEndPicker >
                </mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionList.filter.department.label' | translate }}</mat-label>
                <input matInput
                  formControlName="department" [(ngModel)]="filter.department">
              </mat-form-field>
            </div>

          </div>

        </mat-expansion-panel>
      </mat-accordion>

      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
        <button mat-raised-button (click)="doFilter()"
        color="primary">{{ 'button.filter' | translate }}</button>
        <button mat-button (click)="cleanFilter()">{{ 'button.clean' | translate }}</button>
      </div>

    </mat-expansion-panel>
  </mat-accordion>
</form>